const reviews = [
  {
    name: 'Marcus J.',
    location: 'United States',
    text: 'This AllChinaBuy spreadsheet completely changed how I shop. I used to spend hours searching for reliable sellers — now I just open the sheet and everything is organized by category with QC notes. Saved me so much time and money.',
    rating: 5,
  },
  {
    name: 'Elena R.',
    location: 'United Kingdom',
    text: 'As a beginner, I was overwhelmed by all the options. The buying guides and safety tips in the spreadsheet gave me the confidence to make my first purchase. Highly recommend to anyone new to AllChinaBuy.',
    rating: 5,
  },
  {
    name: 'David K.',
    location: 'Canada',
    text: 'The price comparison feature alone is worth it. I found the same sneakers at three different price points and picked the best deal. The daily updates keep everything fresh too.',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-2">
          What Users Say
        </h2>
        <p className="text-center text-foreground-500 text-sm mb-12">
          Trusted by thousands of shoppers worldwide
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div key={review.name} className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5 italic">
                &ldquo;{review.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-200 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-700">{review.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2 mt-8">
          <div className="flex items-center gap-1.5 bg-accent-100 px-4 py-2 rounded-full">
            <i className="ri-star-fill text-accent-500"></i>
            <span className="text-sm font-bold text-accent-700">4.9</span>
            <span className="text-xs text-accent-600">average rating</span>
          </div>
        </div>
      </div>
    </section>
  );
}